module.exports = __webpack_public_path__ + "img/browser.3f1f6aa0.svg";